const getFullName = (firstName = '', lastName = '') => {
  return (`${firstName} ${lastName}`).trim()
}

export default getFullName
